<template>

  <tab-container :willCheckScroll="true" tabName="Icon Selection" :isTabOpened="isIconTabOpened"  @toggleTab="(toOpen)=>{toggleIconTab(toOpen)}" @bottomScrolled="$refs.iconSelection.generateSeedIcon()" >
    <icon-selection ref="iconSelection" :currentSelectedIcon="userInfo.icon.value" @setNewIcon="(icon)=>{setNewIcon(icon)}" :isForChatRoom="false" ></icon-selection>
  </tab-container>

  <div class="tab-size-position top-30">
    <h5 class="text-purple-400 text-center uppercase text-xl font-bold my-4">Create your profile</h5>
    <div v-if="isSubmittingForm" class="bg-white bg-opacity-90 absolute top-0 left-0 min-h-full min-w-full z-10 flex">
      <div class="table m-auto">
        <h6 class="text-purple-700 text-base uppercase font-semibold text-center">Registering</h6>
        <bubble-loader></bubble-loader>
      </div>
    </div>
    <section class="space-y-5 max-w-md mx-auto">

      <div>
        <label class="text-xs font-bold text-purple-600" >Icon</label>
        <div  @click="toggleIconTab(true)" class="bg-purple-600 rounded-full text-white w-28 h-28 mx-auto flex flex-col text-center pop-click overflow-hidden justify-between ring-4">
          <div v-if="!userInfo.icon.value" class="flex h-full">
            <ion-icon class="text-5xl m-auto" name="images"></ion-icon>
          </div>
          <div v-else class="flex h-full">
            <img :src="userInfo.icon.value" alt="selected icon">
          </div>
          <div v-if="!userInfo.icon.value" class="bg-purple-500 flex py-2">
            <h6 class="text-xs capitalize m-auto leading-3">Pick <br/> chat icon</h6>
          </div>
        </div>
      </div>

      <div class="flex flex-col space-y-2 w-full col-span-9">
        <div class="flex justify-between">
          <label class="text-xs font-bold" :class="[{ 'text-purple-700' : userInfo.username.isValidated},'text-red-700']" for="user-name">Username</label>
          <h6 class="text-xs font-bold" :class="[{ 'text-purple-700' : userInfo.username.isValidated},'text-red-700']" > {{userInfo.username.value.length + '/' + userInfo.username.maxValue }}</h6>
        </div>
        <input class="text-purple-600  focus:outline-none  bg-white font-normal w-full h-10 flex items-center border px-3 text-sm rounded shadow transition-color" id="user-name" placeholder="How shall we call you?" type="text" v-model="userInfo.username.value" :class="[{ 'border-purple-700' : userInfo.username.isValidated},'border-red-700']" :maxlength="userInfo.username.maxValue" />
        <h6 v-if="!userInfo.username.isValidated" class="text-red-600 text-xs font-bold">{{userInfo.username.errorMessage}}</h6>
      </div>

    </section>
    <section class="mt-5 max-w-md mx-auto">
      <h4 @click="submitNewUser" class="btn-default" :class="[{'opacity-50 cursor-default hover:bg-purple-500' : !isAllInputValidated}]" >Enter Chat</h4>
    </section>
  </div>
</template>

<script>

import IconSelection from '@/components/IconSelection.vue';
import BubbleLoader from '@/components/BubbleLoader.vue';
import TabContainer from '@/components/TabContainer.vue';

import firebase from "firebase/app";


export default {
  name : 'SignUp',
  data(){
    return {
      isIconTabOpened : false,
      isSubmittingForm : false,
      iconsRootFilePath : "/profile-icons/",
      defaultIcon : "blank.png",
      userInfo : {
        "username" : {
          "value" : "",
          "isValidated" : true,
          "maxValue" : 50,
          "minValue" : 5,
          "errorMessage" : ""
        },
        "icon" : {
          "value" : this.currentUsersData.photoURL,
          "isValidated" : true,
        }
      }
    }
  },
  props : {
    currentUsersData : Object
  },
  components : {
    'icon-selection' : IconSelection,
    'bubble-loader' : BubbleLoader,
    'tab-container' : TabContainer
  },
  mounted(){
    this.setDefaultForm()
  },
  methods : {
    toggleIconTab(toOpen = null){
      if(toOpen === null)toOpen = !this.isIconTabOpened;
      this.isIconTabOpened = toOpen;
    },
    setDefaultForm(){
      if(this.currentUsersData.displayName){
        this.userInfo.username.value = this.currentUsersData.displayName;
      }else{
        firebase.database().ref().child("registeredUsers").get().then( (snapshot)=>{
          this.userInfo.username.value = 'Guest' + (Object.keys(snapshot.val()).length + 1);
        });
      }

    },
    submitNewUser(){
      if(!this.isAllInputValidated)return;
      const id = this.currentUsersData.uid
      
      firebase.database().ref('users/' + id).set({
        icon : this.userInfo.icon.value,
        username : this.userInfo.username.value,
        chatRoomsId : {}
      }).then(()=>{
        firebase.database().ref('registeredUsers/' + id).set(true).then(()=>{
          this.$router.push({ name : 'Home' });
        });
      }).catch(() => {
        location.reload();
      });
    },
    userIconError(){
      this.userInfo.icon.isValidated = false; 
    },
    setNewIcon(iconUrl){
      this.userInfo.icon.value = iconUrl;
      this.isIconTabOpened = false;
    },
    setDefaultUserInfo(){
      this.userInfo.username.value = this.$root.currentUsersData.displayName;
      this.userInfo.icon.value = this.$root.currentUsersData.photoURL;
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;  
      }
      return url.protocol === "http:" || url.protocol === "https:";
    },
  },
  computed : {
    usernameLength(){
      return this.userInfo.username.value.length;
    },
    isAllInputValidated(){
      if(!this.userInfo.username.isValidated)return false;
      if(!this.userInfo.icon.isValidated)return false;
      return true;
    }
  },
  watch : {
    usernameLength(length){
      if(length <= 0){
        this.userInfo.username.isValidated = false;
        this.userInfo.username.errorMessage = "Username is Required";
        return;
      }else if(length <  this.userInfo.username.minValue ){
        this.userInfo.username.isValidated = false;
        this.userInfo.username.errorMessage = "Username must be atleast "+ this.userInfo.username.minValue+" characters.";
        return;
      }else if(length > this.userInfo.username.maxValue){
        this.userInfo.username.isValidated = false;
        this.userInfo.username.errorMessage = "Username must be no more than "+this.userInfo.username.maxValue+" characters.";
        return;
      }
      this.userInfo.username.isValidated = true;
      this.userInfo.username.errorMessage = "";
    }
  }
}
</script>

<style>

</style>